import { AccountTriageState } from '@interfaces/state';
import { createAction, props } from '@ngrx/store';

export const ClearAccountTriageState = createAction(
  '[Clear Account Triage State] Account Triage: Clear State',
);

export const UpdateAccountTriageSelections = createAction(
  '[Update Account Triage Selection] Account Triage: Update Selection',
  props<{ payload: Partial<AccountTriageState> }>(),
);
